module.exports = __webpack_public_path__ + "static/media/instagram-footer.d1ca82b6.webp";